import { makeStyles } from '@mui/styles';
import { down } from '../../styles/breakpoints';

interface StyleProps {
  isSearchable?: boolean;
  showPagination?: boolean;
  isBackgroundUnique?: boolean;
  isTitleHeader?: boolean;
}

const useStyles = makeStyles<{}, StyleProps>(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px',
    backgroundColor: (props) => props.isBackgroundUnique ? '#f9f9f9' : 'transparent',
    borderRadius: '8px',
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    flexWrap: 'wrap',
    marginBottom: (props) => props.isTitleHeader ? '8px' : 0,
  },
  formControl: {
    '& .MuiOutlinedInput-root': {
      height: '40px',
      '& fieldset': {
        borderColor: '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: '#1976d2',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px',
      fontSize: '14px',
    },
  },
  componentHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  containerTable: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 1px 3px rgba(0,0,0,0.1)',
    '& .MuiTableHead-root': {
      backgroundColor: '#f5f5f5',
    },
    '& .MuiTableCell-head': {
      fontWeight: 600,
      fontSize: '14px',
      color: '#212121',
      borderBottom: '1px solid #e0e0e0',
    },
    '& .MuiTableCell-body': {
      fontSize: '14px',
      borderBottom: '1px solid #e0e0e0',
    },
    '& .MuiTableRow-root:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  iconSort: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.7,
    },
  },
  footerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '8px',
    gap: '16px',
    flexWrap: 'wrap',
    minWidth: 0,

    /*
     * Same defect as CustomTable: this row wraps, but the MUI pagination
     * toolbar inside it does not. Its label + selector + range + arrows need
     * roughly 420px, so below that the toolbar forced the card wider than the
     * screen. Let it wrap and drop the label on phones, where the selector
     * beside it already carries the meaning.
     */
    '& .MuiTablePagination-root': {
      minWidth: 0,
      overflow: 'hidden',
    },
    '& .MuiTablePagination-toolbar': {
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      rowGap: '4px',
      minHeight: 'auto',
      paddingLeft: 0,
    },
    '& .MuiTablePagination-displayedRows': {
      margin: 0,
    },
    '& .MuiTablePagination-selectLabel': {
      margin: 0,
      [down.sm]: { display: 'none' },
    },
  },
}));

export default useStyles;
